<template>
  <div
    class="c-swatch-wrapper"
    :title="message"
    :aria-label="message"
  >
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    message: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.c-swatch-wrapper {
  background: none;
  border: none;
}
</style>
